import React, {useContext, useEffect} from "react";
import {Navigate, useNavigate} from "react-router-dom";
import {AuthContext} from "../Infrastructure/provider/AuthProvider";

const ProtectedRoute = ({element, roles}: any) => {

    const {user, loading} = useContext<any>(AuthContext);

    if (loading) return null;

    if (!user) return <Navigate to="/" replace/>;

    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/403" replace/>; // страница "Доступ запрещен"
    }

    return <>{element}</>;
};

export default ProtectedRoute;
